<div class="modal-header">
  <div class="modal-title">
    <h3 class="mb-0">Assign sites</h3>
    <p class="modal-subtitle mb-0">
      Select the sites you want to add to this vendor.
    </p>
  </div>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="close()"
  ></button>
</div>

<div class="modal-body">
  <div style="height: 500px">
    <app-sites-grid
      [gridName]="'AddVendorToSites'"
      [suppliedQueryData]="suppliedGridQueryData"
      [rowMultiSelectWithClick]="true"
      [rowSelectionType]="'multiple'"
      (selectionChanged)="onSelectionChange($event)"
    ></app-sites-grid>
  </div>
</div>

<div class="modal-footer">
  <div class="action-row justify-end w-100">
    <button type="button" class="btn btn-ghost" (click)="close()">
      Cancel
    </button>
    <button
      type="button"
      class="btn btn-primary"
      [disabled]="disableBtn"
      (click)="addVendorToSites()"
    >
      Add sites
    </button>
  </div>
</div>
